import type { ReactNode } from 'react';

interface Props {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  flush?: boolean;
  footer?: ReactNode;
  className?: string;
}

export function Panel({ title, actions, children, flush, footer, className }: Props) {
  return (
    <section className={`panel${className ? ` ${className}` : ''}`}>
      {title || actions ? (
        <header className="panel__header">
          {typeof title === 'string' ? <h2>{title}</h2> : title}
          {actions ? <div className="row">{actions}</div> : null}
        </header>
      ) : null}
      <div className={`panel__body${flush ? ' panel__body--flush' : ''}`}>{children}</div>
      {footer ? <footer className="panel__footer">{footer}</footer> : null}
    </section>
  );
}
